import React, { useState } from "react";
import "./portfolio.css";
import EducationItem from "./EducationItem";
import ExperienceItem from "./ExperienceItem";

import wtichShadowImg from "../../assets/witchShadow_img.png";
import wtichShadowGameImg1 from "../../assets/wtichShadowGameImg1.png";
import wtichShadowGameImg2 from "../../assets/wtichShadowGameImg2.png";
import wtichShadowGameImg3 from "../../assets/wtichShadowGameImg3.png";
import wtichShadowGameImg4 from "../../assets/wtichShadowGameImg4.png";
import wtichShadowGameImg5 from "../../assets/wtichShadowGameImg5.png";





import artHouseImg from "../../assets/ArtHouse_img.png";
import artHouseGameImg1 from "../../assets/artHouseGameImg1.png";
import artHouseGameImg2 from "../../assets/artHouseGameImg2.png";
import artHouseGameImg3 from "../../assets/artHouseGameImg3.png";
import artHouseGameImg4 from "../../assets/artHouseGameImg4.png";
import artHouseGameImg5 from "../../assets/artHouseGameImg5.png";


import toiletRollvengeImg from "../../assets/ToiletRollvenge_img.png";
import toiletRollvengeGameImg1 from "../../assets/ToiletRollvenge_gameplay1.jpg";
import toiletRollvengeGameImg2 from "../../assets/ToiletRollvenge_gameplay2.jpg";
import toiletRollvengeGameImg3 from "../../assets/ToiletRollvenge_gameplay3.jpg";
import toiletRollvengeGameImg4 from "../../assets/ToiletRollvenge_gameplay4.jpg";
import toiletRollvengeGameImg5 from "../../assets/ToiletRollvenge_gameplay5.jpg";
import toiletRollvengeGameImg6 from "../../assets/ToiletRollvenge_gameplay6.jpg";

import IsabellaImg from "../../assets/IsabellaImg.png";
import IsabellaGameImg1 from "../../assets/IsabellaGameImg1.jpg";
import IsabellaGameImg2 from "../../assets/IsabellaGameImg2.jpg";
import IsabellaGameImg3 from "../../assets/IsabellaGameImg3.jpg";
import IsabellaGameImg4 from "../../assets/IsabellaGameImg4.png";
import IsabellaGameImg5 from "../../assets/IsabellaGameImg5.jpg";


import shootemImg from "../../assets/Shootem_img2.png";
import shootemGameImg1 from "../../assets/Shootem_gameplay_1.gif";
import shootemGameImg2 from "../../assets/Shootem_gameplay_2.gif";

import FPS1 from "../../assets/FPS_demo1.jpg";
import FPS2 from "../../assets/FPS_demo2.jpg";
import FPS3 from "../../assets/FPS_demo3.jpg";
import Puzzle1 from "../../assets/Puzzle_demo1.jpg";

const Portfolio = () => {
    const [toggleState, setToggleState] = useState(1);
    const [expandedItems, setExpandedItems] = useState({});

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const toggleExpand = (itemId) => {
        setExpandedItems((prevState) => ({
            ...prevState,
            [itemId]: !prevState[itemId],
        }));
    };

    return (
        <section className="portfolio section" id="portfolio">
            <h2 className="section__title">Portfolio</h2>
            <span className="section__subtitle">My Journey</span>

            <div className="portfolio__container container">
                <div className="portfolio__tabs">
                    <div
                        className={
                            toggleState === 2
                                ? "portfolio__button portfolio__active button--flex"
                                : "portfolio__button button--flex"
                        }
                        onClick={() => toggleTab(2)}
                    >
                        <i className="uil uil-graduation-cap portfolio__icon">Education</i>
                    </div>

                    <div
                        className={
                            toggleState === 1
                                ? "portfolio__button portfolio__active button--flex"
                                : "portfolio__button button--flex"
                        }
                        onClick={() => toggleTab(1)}
                    >
                        <i className="uil uil-briefcase-alt portfolio__icon">Experience</i>
                    </div>
                </div>

                <div className="portfolio__sections">
                    {toggleState === 2 && (
                        <div className="portfolio__content portfolio__content-active">
                            <EducationItem
                                title="M.S. in Computer Science (Games)"
                                subtitle="University of Southern California (USC)"
                                date="August 2024 - Present"
                                isLast={false}
                            />
                            <EducationItem
                                title="B.A. in Economics, B.S. in Data Science"
                                subtitle="University of Southern California (USC)"
                                date="August 2020 - May 2024"
                                isLast={true}
                            />
                        </div>
                    )}

                    {toggleState === 1 && (
                        <div className="portfolio__content portfolio__content-active">
                            <ExperienceItem
                                title="Independent Project"
                                subtitle="Toilet Rollvenge (Unity)"
                                date="September 2024 - Present"
                                imgSrc={toiletRollvengeImg}
                                subimg1={toiletRollvengeGameImg1}
                                subimg2={toiletRollvengeGameImg2}
                                subimg3={toiletRollvengeGameImg3}
                                subimg4={toiletRollvengeGameImg4}
                                subimg5={toiletRollvengeGameImg5}
                                subimg6={toiletRollvengeGameImg6}
                                expanded={expandedItems[3]}
                                onExpand={toggleExpand}
                                itemId={3}
                                layoutType="left"
                                description={
                                    <>

                                        <a href="https://adrianyang.itch.io/toilet-rollvenge-demo" target="_blank" rel="noopener noreferrer" className="portfolio__trylink">
                                            Try this game here!
                                        </a>
                                        <p>
                                            <strong>"Toilet Rollvenge"</strong> is a 2.5D rage platformer inspired by "Getting Over It with Bennett Foddy," where players face a challenging ascent by controlling a toilet roll with only a single mouse click to jump.
                                            Dropped from a high-level apartment, the goal is to climb back up through various levels and obstacles, relying on precise controls.
                                        </p>
                                        <p>
                                            <strong>Current Focus:</strong> I'm currently developing "Toilet Rollvenge" as a solo project, designing levels and implementing realistic physics for the toilet roll's movements. The physics system is critical to the gameplay experience, ensuring that the roll feels natural and reacts appropriately to different surfaces and obstacles.

                                            To achieve realistic rolling and jumping mechanics, I applied dynamic impulse forces and torque to simulate movement.
                                            Friction is adjusted based on the roll's angle to create varied interactions with different terrains, while raycasts ensure grounded movement.
                                            Sound effects play on collisions, adding feedback, and the x-axis is fixed to maintain a consistent camera view.
                                            These elements make for an engaging, rage-inducing experience that tests player timing and precision.
                                        </p>
                                    </>
                                }
                            />

                            <ExperienceItem
                                title="Lead Designer/Programmer"
                                subtitle="Isabella (Unity)"
                                date="September 2024 - December 2024"
                                imgSrc={IsabellaImg}
                                subimg1={IsabellaGameImg1}
                                subimg2={IsabellaGameImg2}
                                subimg3={IsabellaGameImg3}
                                subimg4={IsabellaGameImg4}
                                subimg5={IsabellaGameImg5}
                                expanded={expandedItems[4]}
                                onExpand={toggleExpand}
                                itemId={4}
                                layoutType="right"
                                description={
                                    <>
                                        <a href="https://adrianyang.itch.io/isabella" target="_blank" rel="noopener noreferrer" className="portfolio__trylink">
                                            Try this game here!
                                        </a>
                                        <p>
                                            <strong>"Isabella"</strong> is a 2D puzzle platformer with a bittersweet narrative, featuring identity-switching mechanics. The story follows a ghost trying to uncover what happened to him and find his way back to his daughter. Set during Halloween, the ghost uses a blanket as a disguise to switch between human and ghost modes, allowing him to interact with two different worlds. 
                                        </p>

                                        <p>
                                            <strong>Development Focus:</strong> I solo programmed the entire game, writing over 30 C# scripts, and took on the majority of design responsibilities, including creating 3 levels and developing various mechanics and puzzle designs, all within a semester. As part of a three-person team, we followed the standard game development process using the Agile methodology. This involved pre-production, crafting the game macro, maintaining burndown charts, conducting stand-up meetings, and achieving key milestones such as the vertical slice, alpha, and beta phases.
                                        </p>

                                    </>}
                            />

                            <ExperienceItem
                                title="UIUX Lead"
                                subtitle="Art House (Unity)"
                                date="August 2024 - Present"
                                imgSrc={artHouseImg}
                                subimg1={artHouseGameImg1}
                                subimg2={artHouseGameImg2}
                                subimg3={artHouseGameImg3}
                                subimg4={artHouseGameImg4}
                                subimg5={artHouseGameImg5}
                                expanded={expandedItems[2]}
                                onExpand={toggleExpand}
                                itemId={2}
                                layoutType="left"
                                description={
                                    <>
                                        <p>
                                            <strong>"Art House"</strong> is a 2D platformer where a mother and her children, returning to their grandmother’s home to pack up her belongings after her death,
                                            are trapped inside her paintings. The grandmother’s spirit pulls the children into the paintings, forcing the mother to navigate through various layers—background, midground, and foreground—using the characters’ unique abilities to confront her grief.
                                        </p>
                                        <p>
                                            <strong>Current Focus:</strong> I'm working as the UI/UX Lead, developing the game's user interface by creating detailed game flowchart overall and wireframes for each scene.
                                            I'm designing the layout for menus, game interface elements, and interactive icons to ensure a seamless player experience.
                                            My focus is on enhancing usability, accessibility, and aesthetic appeal while aligning with the game's themes.
                                        </p>

                                    </>
                                }
                            />

                            <ExperienceItem
                                title="Design Lead/Programmer"
                                subtitle="The Witch in Shadow (Unity)"
                                date="August 2024 - Present"
                                imgSrc={wtichShadowImg}
                                subimg1={wtichShadowGameImg1}
                                subimg2={wtichShadowGameImg2}
                                subimg3={wtichShadowGameImg3}
                                subimg4={wtichShadowGameImg4}
                                subimg5={wtichShadowGameImg5}
                                expanded={expandedItems[1]}
                                onExpand={toggleExpand}
                                itemId={1}
                                layoutType="right"
                                description={
                                    <>
                                        <p>
                                            <strong>"The Witch in Shadow"</strong> is a 2D platformer where a young girl
                                            switches between the real world and her imagined world to escape from
                                            monsters, eventually learning new abilities to confront and defeat them.
                                        </p>
                                        <p>
                                            <strong>Development Focus:</strong> I'm primarily working on level design
                                            (creating 3 to 4 levels with different objectives, obstacles, and endings),
                                            gameplay design (designing combat mechanisms, player core systems, and
                                            interactive items), and gameplay engineering (programming combat logic,
                                            abilities, and world items) to bring the world of "The Witch in Shadow" to
                                            life.
                                        </p>
                                    </>
                                }
                            />


                            <ExperienceItem
                                title="Independent Project"
                                subtitle="Shootem! (Godot)"
                                date="July 2024 - August 2024"
                                imgSrc={shootemImg}
                                subimg1={shootemGameImg1}
                                subimg2={shootemGameImg2}
                                expanded={expandedItems[5]}
                                onExpand={toggleExpand}
                                itemId={5}
                                layoutType="left"
                                description={
                                    <>

                                        <a href="https://adrianyang.itch.io/shootem" target="_blank" rel="noopener noreferrer" className="portfolio__trylink">
                                            Try this game here!
                                        </a>
                                        <p>
                                            <strong>"Shootem!"</strong> is a 2D top-down shooter game for both PC and mobile where the player must survive as long as possible through waves of monster attacks, while collecting coins and points to unlock powerful weapons, gear, and buffs. The game also features a perk system that grants players additional abilities every 200 points, helping them survive longer.
                                        </p>

                                        <p>
                                            <strong>Development Focus:</strong> I worked on implementing the gameplay system, designing weapons and monsters, developing enemy AI, and creating an auto-tracking shooting system for turrets and helpers to enhance the player's survival experience.
                                        </p>

                                    </>
                                }
                            />


                            <ExperienceItem
                                title="School Project"
                                subtitle="Puzzle/Local co-op 3D FPS (Unreal)"
                                date="Aug 2023 - Dec 2023"
                                imgSrc={FPS1}
                                subimg1={FPS2}
                                subimg2={FPS3}
                                subimg3={Puzzle1}
                                expanded={expandedItems[6]}
                                onExpand={toggleExpand}
                                itemId={6}
                                layoutType="right"
                                description={
                                    <>
                                        <p>
                                            This is a school project consisting of two parts: a 3D top-down puzzle-solving game with a stealth system and enemy AI, and a 3D FPS local co-op game featuring a chat system, local client hosting, and team score system.
                                        </p>

                                        <p>
                                            <strong>Development Focus:</strong> For the puzzle game, I worked on implementing various puzzle objects, with enemy AI that chases the player until they enter stealth mode. In the FPS project, I focused on implementing the local client and chat system, allowing players to either play via split-screen or connect to each other through Steam for cooperative gameplay.
                                        </p>


                                    </>
                                }
                            />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
